import { isRef, computed, shallowRef } from "vue";
import { u as useTemplateRef } from "./useTemplateRef-58eb28b3.mjs";
const extractHTMLElement = (el) => el && "$el" in el ? el.$el : el;
const useHTMLElement = (key) => {
  if (isRef(key)) {
    return computed({
      get() {
        return extractHTMLElement(key.value);
      },
      set(value) {
        key.value = value;
      }
    });
  }
  if (key) {
    const el2 = useTemplateRef(key);
    return computed({
      get() {
        return extractHTMLElement(el2.value);
      },
      set(value) {
        el2.value = value;
      }
    });
  }
  const el = shallowRef();
  return computed({
    set(value) {
      el.value = extractHTMLElement(value);
    },
    get() {
      return el.value;
    }
  });
};
export {
  extractHTMLElement as e,
  useHTMLElement as u
};
//# sourceMappingURL=useHTMLElement-beee793a.mjs.map
